export default __webpack_public_path__ + "static/media/profile.2dcf6dc0.svg";